module.exports = __webpack_public_path__ + "static/media/logo.e597a920.svg";